<template>
  <div>
    <div class="col-sm-6">
      <div class="h-title">{{$t('Security.Role.device')}}</div>
      <div class="e-input-group m-b-8">
        <ejs-textbox :placeholder="$t('Security.auth.deviceSearch')" v-model="keyword" :change="search">
          <span class="icon hero-icon hero-icon-search"></span>
        </ejs-textbox>
      </div>
      <div class="tree-box h-security-role-rightTree">
        <tree
          :setting="nodeAuthSetting"
          :nodes="nodeAuthNodes"
          @onCreated="handleNodeAuthCreated"
          @onCheck="checkNodeAuth"/>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="h-title">{{$t('Security.Role.el')}}</div>
      <div class="e-input-group m-b-8">
        <ejs-textbox :placeholder="$t('Security.auth.clusterSearch')" v-model="clusterKeyword" :change="clusterSearch">
          <span class="icon hero-icon hero-icon-search"></span>
        </ejs-textbox>
      </div>
      <div class="tree-box h-security-role-rightTree">
        <tree
          :setting="clusterAuthSetting"
          :nodes="clusterAuthNodes"
          @onCreated="handleClusterAuthCreated"
          @onCheck="checkClusterAuth"/>
      </div>
    </div>
  </div>
</template>

<script>
import tree from 'vue-giant-tree'

export default {
  name: 'AddRoleP2',
  components: {
    tree
  },
  data () {
    return {
      roleId: '',
      keyword: '',
      clusterKeyword: '',
      nodeAuthTreeObj: '',
      clusterAuthTreeObj: '',
      nodeAuthNodes: [],
      clusterAuthNodes: [],
      filterNodes: [],
      clusterFilterNodes: [],
      nodeAuthSetting: {
        data: {
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'parentId',
            rootPId: 0
          },
          key: {
            title: 'ip'
          }
        },
        check: {
          chkboxType: { 'Y': 'ps', 'N':'ps' },
          chkStyle: 'checkbox',
          enable: true
        }
      },
      clusterAuthSetting: {
        data: {
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'parentId',
            rootPId: 0
          }
        },
        check: {
          chkboxType: { 'Y': 'ps', 'N':'ps' },
          chkStyle: 'checkbox',
          enable: true
        }
      },
      nodeIdChecked: []
    }
  },
  methods: {
    handleNodeAuthCreated(ztreeObj) {
      this.nodeAuthTreeObj = ztreeObj
      this.nodeAuthTreeObj.expandAll(true)
      this.setNodeChecked()
    },
    handleClusterAuthCreated(ztreeObj) {
      this.clusterAuthTreeObj = ztreeObj
      this.clusterAuthTreeObj.expandAll(true)
      this.setClusterChecked()
    },
    initTreeData() {
      this.findNodeData()
      this.findClusterData()
    },
    findNodeData() {
      const url = "/lte/ems/auth/getEnvAndDev";
      this.axios.get(url).then(response => {
        const result = response.data.filter(node => (node.typeCode!=12001 && node.typeCode!=12002 && node.typeCode!=12003));
        this.filterNodes = result
        this.nodeAuthNodes = result
      });
    },
    findClusterData() {
      const url = "/lte/ems/auth/findEnvElement";
      this.axios.get(url, { params: {} }).then(response => {
        const result = response.data
        this.clusterFilterNodes = result
        this.clusterAuthNodes = result
      })
    },
    checkNodeAuth(event, treeId, treeNode) {
      const subNodes = treeNode.children
      const checkedStatus = treeNode.checked
      if (!!subNodes) {
        // 子节点勾选
        subNodes.forEach(node => {
          this.nodeAuthTreeObj.checkNode(node, checkedStatus, false, false)
        });
      }
      this.setChildProps()
    },
    // cancelCheckedNodes(subCheckedNodes) {
    //   if (!!subCheckedNodes) {
    //     subCheckedNodes.forEach(node => {
    //       this.nodeAuthTreeObj.checkNode(node, false, false, false)
    //     });
    //   }
    // },
    // disabledNodeCheck(subNodes, disabledStatus) {
    //   if (!!subNodes) {
    //     subNodes.forEach(node => {
    //       this.nodeAuthTreeObj.setChkDisabled(node, disabledStatus, false, true)
    //     });
    //   }
    // },
    checkClusterAuth(event, treeId, treeNode) {
      const subNodes = treeNode.children
      const checkedStatus = treeNode.checked
      this.checkedSubNode(subNodes, checkedStatus)
      this.setChildProps()
    },
    checkedSubNode(subNodes, checkedStatus) {
      if (!!subNodes) {
        // 子节点勾选
        subNodes.forEach(node => {
          this.clusterAuthTreeObj.checkNode(node, checkedStatus, false, false)
        });
      }
    },
    search() {
      // 前台过滤
      this.keyword = this.keyword.trim()
      if (this.keyword == "") {
        this.nodeAuthNodes = this.filterNodes
      } else{
        const fuzzyResult = this.filterNodes.filter(node => node.name.indexOf(this.keyword)!=-1)
        let filterResult = []
        fuzzyResult.forEach(item => {
          let filterTemp = this.filterParentNode(item)
          filterTemp.forEach(node => {
            if (filterResult.filter(r => r.id == node.id).length == 0){
              filterResult.push(node)
            }
          })
        })
        this.nodeAuthNodes = filterResult
      }
    },
    clusterSearch() {
      // 前台过滤
      this.clusterKeyword = this.clusterKeyword.trim()
      if (this.clusterKeyword == "") {
        this.clusterAuthNodes = this.clusterFilterNodes
      } else{
        const fuzzyResult = this.clusterFilterNodes.filter(node => node.name.indexOf(this.clusterKeyword)!=-1)
        let filterResult = []
        fuzzyResult.forEach(item => {
          let filterTemp = this.filterClusterParentNode(item)
          filterTemp.forEach(node => {
            if (filterResult.filter(r => r.id == node.id).length == 0){
              filterResult.push(node)
            }
          })
        })
        this.clusterAuthNodes = filterResult
      }
    },
    filterParentNode(item) {
      let nextSubNodes = []
      if (item.parentId != 0) {
        nextSubNodes = this.filterParentNode(this.filterNodes.filter(node => node.id == item.parentId)[0])
      }
      nextSubNodes.push(item)
      return nextSubNodes;
    },
    filterClusterParentNode(item) {
      let nextSubNodes = []
      if (item.parentId != 0) {
        nextSubNodes = this.filterClusterParentNode(this.clusterFilterNodes.filter(node => node.id == item.parentId)[0])
      }
      nextSubNodes.push(item)
      return nextSubNodes;
    },
    setNodeChecked() {
      const That = this;
      let temp = this.nodeIdChecked.filter(x => x.nodeType==0 || x.nodeType==3)
      if (temp.length>0) {
        temp.forEach(item => {
          let pnode = That.nodeAuthTreeObj.getNodeByParam('id', item.nodeId)
          if (pnode!=null) {
            // let subCheckedNodes = That.nodeAuthTreeObj.getNodesByParam('checked', true, pnode)
            That.nodeAuthTreeObj.checkNode(pnode, true, true, false)
            // That.cancelCheckedNodes(subCheckedNodes)
            // That.disabledNodeCheck(pnode.children, true)
          }
        })
      }
    },
    setClusterChecked() {
      const That = this;
      let temp = this.nodeIdChecked.filter(x => x.nodeType==4)
      if (temp.length>0) {
        temp.forEach(item => {
          let pnode = That.clusterAuthTreeObj.getNodeByParam('id', item.nodeId)
          That.clusterAuthTreeObj.checkNode(pnode, true, true, false)
        })
      }
    },
    setChildProps() {
      let clusterCheckedNodes = this.clusterAuthTreeObj.getCheckedNodes(true)
      let nodeCheckedNodes = this.nodeAuthTreeObj.getCheckedNodes(true)
      let nodeIds = []
      clusterCheckedNodes.forEach(node => {
        nodeIds.push({ 'nodeId': node.id, 'typeCode': node.typeCode })
      })
      nodeCheckedNodes.forEach(node => {
        nodeIds.push({ 'nodeId': node.id, 'typeCode': node.typeCode })
      })
      this.$emit("childProps", {
        nodeDomain: nodeIds,
      });
    },
    init(roleParams){
      this.roleId = roleParams.roleId;
      this.nodeIdChecked = roleParams.nodeIdList;
      this.$emit("childProps", {
        nodeDomain: this.nodeIdChecked,
      });
    }
  },
  mounted () {
  }
}
</script>
<style scoped>
.tree-box {
  width: 340px;
  max-height: 450px;
}
</style>

